module.exports = __webpack_public_path__ + "img/0-02-0a-b22b00cbcb5d6a4f2d61f15ad2fee700aa6213e8db0b6a89d8b28795541708cb_dc1c6741.71b9ae81.jpg";